module.exports = __webpack_public_path__ + "static/advantages_rain_garden-b5d5e897341cb908ec6a5cbec62b6c59.gif";